import moment from 'moment';
import TableField from "@/components/common/table-field/TableField.vue";

const defaultEl = {
    page: 1,
    total: 0,
    sort_column: null,
    sort_direction: null
}
export default {
    name: 'ShowHistoryAccounts',
    components: {
        TableField
    },

    data () {
        return {
            list: [],
            loading: false,
            clientId: null,
            name: null,
            params: this.BasicHelper.cloneObject(defaultEl)
        }
    },

    computed: {
        columns() {
            return [
                { title: this.$t('showHistoryAccounts.date'), key: "date", sortable: true, minWidth: "110px" },
                { title: this.$t('showHistoryAccounts.trans'), key: "trans", sortable: true },
                { title: this.$t('showHistoryAccounts.currency'), key: "currency", sortable: true },
                { title: this.$t('showHistoryAccounts.priceCY'), key: "priceCurrency", sortable: true, minWidth: "200px" },
                { title: this.$t('showHistoryAccounts.price'), key: "price", sortable: true },
                { title: this.$t('showHistoryAccounts.balance'), key: "balance", sortable: true },
                { title: this.$t('showHistoryAccounts.info'), key: "info", sortable: true }
            ]
        }
    },

    methods: {
        getPageSize() {
            const pageSize = localStorage.getItem('history-accounts-page-size');
            return pageSize ? Number(pageSize) : 20;
        },

        show (client_id) {
            this.resetState();
            this.params.pageSize = this.getPageSize();
            this.clientId = client_id;
            this.populateData();
            this.$refs['modal-window'].show();
        },

        resetState() {
            this.list = [];
            this.name = null;
            this.loading = false;
            this.params = this.BasicHelper.cloneObject(defaultEl);
        },

        async populateData() {
            this.loading = true;
            try {
                const response = await this.getHistory(this.clientId);
                if (!response || response.error || response.canceled) return;
                const { data, pagination } = response;
                this.list = this.BasicHelper.cloneObject(data.list);
                this.name = data.name;
                this.params = {
                    ...this.params,
                    ...pagination
                }
            } finally {
                this.loading = false;
            }
        },

        async getHistory(clientId) {
            return this.ApiRequest.requestAsync(
                `billing/debtors/accounts/history/${clientId}`,
                this.ApiRequest.REQUEST_POST,
                this.params,
                `debtors-history-${clientId}`,
                true
            );
        },

        formatDate(date) {
            return moment(date).format('DD.MM.YYYY')
        },

        formatNumber(value) {
            if (value === null || value === undefined) return ''
            const num = Number(value)
            return Number.isInteger(num) ? num.toString() : num.toFixed(2);
        },

        close () {
            this.$refs['modal-window'].hide();
        }
    }
}